import { AppBar, Box, Container, Grid, List, ListItem, Toolbar, Typography } from '@mui/material';
import i18next from 'i18next';
import { inject, observer } from 'mobx-react';
import QRCode from 'qrcode.react';
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import Moment from 'react-moment';
import { withRouter } from 'react-router-dom';
import api from '../../api';
import PaymentMethodEnum from '../../enums/PaymentMethodEnum';
import ReceiveMethodEnum from '../../enums/ReceiveMethodEnum';
import CurrencyDisplay from '../common/CurrencyDisplay';
import DisplayMenu from '../common/DisplayMenu';
import DisplaySetMenu from '../common/DisplaySetMenu';
import DisplayTopping from '../common/DisplayTopping';
import Header from '../common/Header';
import Progress from '../common/Progress';
import Bottom from './Bottom';
import OrderStep from './OrderStep';

@inject('commonStore', 'orderStore', 'menuStore')
@observer
class OrderDetail extends Component {
  state = {
    isLiteOrder: false,
  };

  async componentDidMount() {
    const { commonStore, orderStore, menuStore, match } = this.props;

    const companyId = match.params.companyId;
    const storeCode = match.params.storeCode;
    const orderId = match.params.orderId;

    // 매장 데이터 세팅
    await commonStore.setData(companyId.toLowerCase(), storeCode);

    // 주문 조회
    if (!orderStore.order) {
      try {
        const response = await api.getSale(companyId, storeCode, orderId, i18next.languages[0]);

        orderStore.setOrder(response.data);
      } catch (error) {
        commonStore.setError(error);
        throw error;
      }
    }

    // 현재 조회 된 상점 데이터가 없거나 (카톡 링크로 접속한 경우나 세션스토리지 데이터가 삭제된 경우)
    // 조회한 주문의 상점과 현재 조회된 상점이 다른 경우
    // 매장 데이터 다시 조회
    if (
      !menuStore.storeData ||
      orderStore.order.companyId !== menuStore.storeData.companyId ||
      orderStore.order.storeCode !== menuStore.storeData.storeCode
    ) {
      commonStore.setData(orderStore.order.companyId, orderStore.order.storeCode);
    }

    // 주문 상태 갱신 (5초)
    const interval = setInterval(async () => await orderStore.setOrderStatus(companyId, storeCode, orderId), 5000);
    orderStore.setStatusCheckInterval(interval);

    this.setState(() => ({ isLiteOrder: !this.props.orderStore.order.extOrderNo }));
  }

  componentWillUnmount() {
    clearInterval(this.props.orderStore.statusCheckInterval);
  }

  render() {
    const { orderStore, t } = this.props;
    const query = new URLSearchParams(this.props.location.search);
    if (!orderStore.order) return <Progress />;
    return (
      <React.Fragment>
        {/* 상세페이지 링크로 들어온 경우 헤더에 타이틀만 사용 */}
        {query.get('link') ? (
          <AppBar position="fixed" color="primary" style={{ boxShadow: 'none' }}>
            <Toolbar style={{ minHeight: '60px' }}>
              {/** 타이틀 */}
              <Typography align="center" style={{ flexGrow: 1 }}>
                {t('order.title.detail')}
              </Typography>
            </Toolbar>
          </AppBar>
        ) : (
          <Header iconType="CART" title={t('order.title.detail')} />
        )}

        <div className="contents-full">
          <Box sx={{ backgroundColor: theme => theme.palette.secondary.main }} className="order-detail-top clear-fix">
            <div className="wait-number">
              {t('order.label.orderNumber')} {orderStore.order.waitNum}
            </div>
            <div className="order-date">
              <Moment format="YYYY-MM-DD HH:mm:ss">{orderStore.order.regDate}</Moment>
            </div>
          </Box>

          {/* 현재 주문 단계 표시 */}
          <OrderStep />

          <Container>
            <div className="order-detail-box">
              <div className="box-title">{t('order.label.info')}</div>
              <div className="box-contents">
                <Grid container spacing={2}>
                  <Grid item container direction="row">
                    <Grid item>
                      <b>{t('order.label.receiptNumber')}</b>
                    </Grid>
                    <Grid item xs>
                      <Typography align="right">{orderStore.order.receiptNum}</Typography>
                    </Grid>
                  </Grid>
                  <Grid item container direction="row">
                    <Grid item>
                      <b>{t('shop.label.name')}</b>
                    </Grid>
                    <Grid item xs>
                      <Typography align="right">{orderStore.order.storeName}</Typography>
                    </Grid>
                  </Grid>
                  <Grid item container direction="row">
                    <Grid item>
                      <b>{t('order.label.receiveMethod')}</b>
                    </Grid>
                    <Grid item xs>
                      <Typography align="right">
                        {ReceiveMethodEnum.properties[orderStore.order.receiveMethodCode].name}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid item container direction="row">
                    <Grid item>
                      <b>{t('payment.label.amount')}</b>
                    </Grid>
                    <Grid item xs container direction="column">
                      {orderStore.order.payments.map((payment, index) => (
                        <Grid item container direction="row" key={index}>
                          <Grid item xs style={{ textAlign: 'right' }}>
                            ({PaymentMethodEnum.properties[payment.methodCode] || t('payment.label.etc')}){' '}
                            <CurrencyDisplay amount={Number(payment.amt)} fontWeight="normal" />
                          </Grid>
                        </Grid>
                      ))}
                    </Grid>
                  </Grid>
                </Grid>
              </div>
            </div>
            <div className="order-detail-box">
              <div className="box-title">{t('menu.label.info')}</div>
              <div className="box-contents" style={{ paddingTop: 0 }}>
                <List className="menu-list">
                  {orderStore.order.menus.map((menu, index) => (
                    <ListItem className="menu-detail" key={index}>
                      {/* 메뉴 */}
                      <Grid container>
                        <DisplayMenu
                          name={menu.itemCode === '099983' ? t('order.label.DeliveryFee') : menu.name}
                          qty={menu.qty}
                          amount={menu.supplyAmount + menu.tax + menu.tax1}
                        />

                        {/* 토핑 */}
                        {menu.toppingGroups && menu.toppingGroups.length > 0 && (
                          <DisplayTopping toppingGroups={menu.toppingGroups} />
                        )}

                        {/* 세트 메뉴 */}
                        {menu.setMenuGroups && menu.setMenuGroups.length > 0 && (
                          <DisplaySetMenu setMenuGroups={menu.setMenuGroups} />
                        )}
                      </Grid>
                    </ListItem>
                  ))}
                </List>
                <Grid container direction="row" style={{ paddingTop: '16px' }}>
                  <Grid item>
                    <span style={{ fontSize: '18px', fontWeight: 'bold' }}>{t('payment.label.totalAmount')}</span>
                  </Grid>
                  <Grid item xs style={{ textAlign: 'right', fontWeight: 'bold' }}>
                    <CurrencyDisplay amount={orderStore.order.finalAmount} type="emphasis" size="large" />
                  </Grid>
                </Grid>
              </div>
            </div>

            {orderStore.order.lockerQR && (
              <div className="order-detail-box">
                <div className="box-title" style={{ textAlign: 'center' }}>
                  Smart Locker QR
                </div>
                <div className="box-contents" style={{ padding: '7px 0', textAlign: 'center' }}>
                  <QRCode
                    value={orderStore.order.lockerQR}
                    renderAs="svg"
                    includeMargin="true"
                    style={{ width: '80%', height: '80%' }}
                  />
                </div>
              </div>
            )}
          </Container>
        </div>

        {/* 확인 버튼 (마장동 주문일떈 버튼 숨김)*/}
        {this.state.isLiteOrder && <Bottom mainLink={`/${orderStore.order.companyId}/${orderStore.order.storeCode}`} />}
      </React.Fragment>
    );
  }
}

export default withRouter(withTranslation()(OrderDetail));
